import { useBreakpointsContext } from "../components/Breakpoints/context";
/**
 * Use this hook if you want to get the current `BreakpointVariant`
 *
 * This hook only works inside a `<Breakpoints />` component
 */
export const useGetBreakpointPropValue = () => {
    const { index } = useBreakpointsContext();
    return (value) => {
        if (Array.isArray(value)) {
            if (index === -1) {
                console.warn("Breakpoint values (e.g. [1,3]) are only support in (sub)elements of the Breakpoint component");
                return value[0];
            }
            return value[index];
        }
        return value;
    };
};
export default useGetBreakpointPropValue;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXNlR2V0QnJlYWtwb2ludFByb3BWYWx1ZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9ob29rcy91c2VHZXRCcmVha3BvaW50UHJvcFZhbHVlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE9BQU8sRUFBRSxxQkFBcUIsRUFBRSxNQUFNLG1DQUFtQyxDQUFDO0FBTzFFOzs7O0dBSUc7QUFDSCxNQUFNLENBQUMsTUFBTSx5QkFBeUIsR0FBRyxHQUVkLEVBQUU7SUFDM0IsTUFBTSxFQUFFLEtBQUssRUFBRSxHQUFHLHFCQUFxQixFQUFFLENBQUM7SUFFMUMsT0FBTyxDQUFDLEtBQUssRUFBRSxFQUFFO1FBQ2YsSUFBSSxLQUFLLENBQUMsT0FBTyxDQUFDLEtBQUssQ0FBQyxFQUFFLENBQUM7WUFDekIsSUFBSSxLQUFLLEtBQUssQ0FBQyxDQUFDLEVBQUUsQ0FBQztnQkFDakIsT0FBTyxDQUFDLElBQUksQ0FDViw4RkFBOEYsQ0FDL0YsQ0FBQztnQkFDRixPQUFPLEtBQUssQ0FBQyxDQUFDLENBQUMsQ0FBQztZQUNsQixDQUFDO1lBRUQsT0FBTyxLQUFLLENBQUMsS0FBSyxDQUFDLENBQUM7UUFDdEIsQ0FBQztRQUVELE9BQU8sS0FBK0IsQ0FBQztJQUN6QyxDQUFDLENBQUM7QUFDSixDQUFDLENBQUM7QUFFRixlQUFlLHlCQUF5QixDQUFDIn0=